import { URL } from "./MainAPILink";
import SetCookies from "Cookies/setCookies";
import RemoveCookies from "Cookies/removeCookies";
import axios from "axios";
const Login = async ({ phone, password, dispatch }) => {
  try {
    const response = await axios.post(URL + "auth/admin/login", {
      phone: phone,
      password: password,
    });
    if (response.data) {
      await SetCookies("userData", JSON.stringify(response.data.data.access_token));
    }
    return response.data.data;
  } catch (err) {
    // CatchMessage(err, dispatch);
    console.log(err);
    return null;
  }
};
// Clears every client-side trace of the session (cookie + cached user data).
// NOTE: no server-side logout endpoint is called because none exists in this codebase;
// if the backend gets one (e.g. to revoke the token), call it here before clearing.
const Logout = async () => {
  try {
    await RemoveCookies("userData");
    localStorage.removeItem("userData");
    return true;
  } catch (err) {
    console.log(err);
    return false;
  }
};
const AutoLogin = async (args) => {
  try {
    const response = await axios.post(URL + "auth/auto_login", {
      authorization: `${args}`,
      device_token: "WebApp",
    });

    if (response.data) {
      await RemoveCookies("userData");
      await SetCookies("userData", JSON.stringify(response.data.data.access_token));
    }

    return response.data.data;
  } catch (err) {
    console.log(err);
    if (err.response.data.status == 422) {
      await RemoveCookies("userData");
      localStorage.removeItem("userData");
    }
    return null;
  }
};
export { Login, AutoLogin, Logout };
